var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "restricted-content-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "restricted-content-wrapper-inner upgrade-layout-default",
      },
      [
        _c(
          "b-container",
          [
            _c(
              "b-row",
              [
                _c("b-col", { staticClass: "title restricted-content-title" }, [
                  _c("span", { staticClass: "restricted-content-icon" }, [
                    _vm._v(" "),
                  ]),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.title))]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { staticClass: "login", attrs: { cols: "6" } }, [
                  _c(
                    "div",
                    { staticClass: "login-inner" },
                    [
                      _c("strong", [_vm._v("Login to your Account")]),
                      _vm._v(" "),
                      _c("login-subform"),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "signup-cta", attrs: { cols: _vm.colSize } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-inner" },
                      [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.content) },
                        }),
                        _vm._v(" "),
                        _vm.join || _vm.link
                          ? [
                              _c("span", { staticClass: "links" }, [
                                _vm.join
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "join-link css-button",
                                        attrs: { href: _vm.join },
                                      },
                                      [_vm._v("Join now")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.link
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-learn-more learn-more",
                                        attrs: { href: _vm.link },
                                      },
                                      [_vm._v("Learn more")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }